import * as React from 'react';
import type { SVGProps } from 'react';

const SvgPaywallStepComplete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <path
      fill="#4B7EFF"
      fillRule="evenodd"
      d="M12.5 0C5.596 0 0 5.596 0 12.5S5.596 25 12.5 25 25 19.404 25 12.5 19.404 0 12.5 0m4.717 10.167a1.25 1.25 0 0 0-1.935-1.583l-4.75 5.805-1.523-1.523a1.25 1.25 0 0 0-1.768 1.768l2.5 2.5c.25.25.593.383.946.366a1.25 1.25 0 0 0 .905-.457z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgPaywallStepComplete;
